import type { GetServerSideProps } from 'next'
import React from 'react'
import { ProfilePage } from '@features/profile/pages/ProfilePage'
import { AppLayout } from '@components/layouts/AppLayout'
import { maintenanceHandler } from '@lib/maintenanceHandler'

function Profile({ slug }: { slug: string }) {
  return (
    <AppLayout>
      <ProfilePage slug={slug} />
    </AppLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const slug = params?.slug
  return maintenanceHandler({
    key: `profile-${slug}`,
    slug,
  })
}

export default Profile
